import { Injectable, isDevMode } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { ModulTozsamosciService } from '../auth-lib/src/public-api';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  notificationHubConnection: HubConnection;

  constructor(
    private mtService: ModulTozsamosciService
  ) {
    this.buildConnection();
  }

  buildConnection() {
    this.notificationHubConnection = new HubConnectionBuilder()
    .withUrl(environment.signalRUrl, { accessTokenFactory: () => this.mtService.getAccessToken()  })
    .withAutomaticReconnect()
    .build();

    this.notificationHubConnection
    .start()
    .then(() => { isDevMode() && console.log('connection started') });
  }

  /*
  public addTransferChartDataListener = () => {
    this.hubConnection.on('transferchartdata', (data) => {
      this.data = data;
      console.log(data);
    });
  }
  */

}
